module.exports = __webpack_public_path__ + "static/mesh-bg-vertical-75fa8eb50e0c3fe8417052577e7b5dd0.png";